import { useMemo } from "react";
import { useAppSelector } from "../../store/hooks";
import { selectIsAdmin } from "../../store/authSelectors";
import { useGetQuery } from "../../store/slices/apiSlice";
import { Company, Project } from "../../store/types";

export interface FilterOption {
  label: string;
  value: string;
}

/** Уникальные названия из справочника — опции дропдауна, отсортированные по алфавиту */
const toNameOptions = (
  items: { name?: string | null }[] | null | undefined
): FilterOption[] => {
  if (!Array.isArray(items)) return [];

  const names = new Set<string>();
  items.forEach((item) => {
    const name = item?.name?.trim();
    if (name) names.add(name);
  });

  return Array.from(names)
    .sort((a, b) => a.localeCompare(b, "ru"))
    .map((name) => ({ label: name, value: name }));
};

/** Список компаний с API для фильтра-дропдауна колонки «Компания» */
export const useCompanyFilterOptions = (): FilterOption[] => {
  const isAdmin = useAppSelector(selectIsAdmin);
  const companiesEP = useAppSelector((state) => state.endpoints.companies);

  const { data } = useGetQuery(companiesEP, {
    skip: !companiesEP || !isAdmin,
  });

  return useMemo(() => toNameOptions(data as Company[] | undefined), [data]);
};

/** Список проектов с API для фильтра-дропдауна колонки «Программное обеспечение» */
export const useProjectFilterOptions = (): FilterOption[] => {
  const isAdmin = useAppSelector(selectIsAdmin);
  const projectsEP = useAppSelector((state) => state.endpoints.projects);

  const { data } = useGetQuery(projectsEP, {
    skip: !projectsEP || !isAdmin,
  });

  return useMemo(() => toNameOptions(data as Project[] | undefined), [data]);
};
